import { createActions, createReducer } from 'reduxsauce'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    removeExercicioConsultaMetasEducacao: ['exercicio'],
    removeMesLiquidacaoConsultaMetasEducacao: ['mesLiquidacao'],
    removeDescricaoMetaConsultaMetasEducacao: [],

    setMostraAplicarFiltroConsultaMetasEducacao: [],
    limpaFiltroConsultaMetasEducacao: [],
    aplicarFiltroConsultaMetasEducacao: ['filtro'],
})

const INITIAL_STATE = {
    exercicio: [],
    mesLiquidacao: [],
    descricaoMeta: '',
    mostraAplicarFiltro: false,
}

const removeExercicio = (state = INITIAL_STATE, action) => {
    state.exercicio.splice(state.exercicio.indexOf(action.exercicio), 1)
    state.exercicio = Array.from(state.exercicio)
    return { ...state, mostraAplicarFiltro: true }
}

const removeMesLiquidacao = (state = INITIAL_STATE, action) => {
    state.mesLiquidacao.splice(state.mesLiquidacao.indexOf(action.mesLiquidacao), 1)
    state.mesLiquidacao = Array.from(state.mesLiquidacao)
    return { ...state, mostraAplicarFiltro: true }
}

const removeDescricaoMeta = (state = INITIAL_STATE, action) => {
    return { ...state, descricaoMeta: '', mostraAplicarFiltro: true }
}

const setMostraAplicarFiltro = (state = INITIAL_STATE, action) => {
    return { ...state, mostraAplicarFiltro: !state.mostraAplicarFiltro }
}

const aplicarFiltro = (state = INITIAL_STATE, action) => {
    action.filtro.mostraAplicarFiltro = false
    return action.filtro
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.REMOVE_EXERCICIO_CONSULTA_METAS_EDUCACAO]: removeExercicio,
    [Types.REMOVE_MES_LIQUIDACAO_CONSULTA_METAS_EDUCACAO]: removeMesLiquidacao,
    [Types.REMOVE_DESCRICAO_META_CONSULTA_METAS_EDUCACAO]: removeDescricaoMeta,
    [Types.SET_MOSTRA_APLICAR_FILTRO_CONSULTA_METAS_EDUCACAO]: setMostraAplicarFiltro,
    [Types.LIMPA_FILTRO_CONSULTA_METAS_EDUCACAO]: limpaFiltro,
    [Types.APLICAR_FILTRO_CONSULTA_METAS_EDUCACAO]: aplicarFiltro,
})
